import * as React from 'react';
import { PhaseErrorContext } from '@/context';
import { PhaseNameCase, StatusPhase } from '@/interfaces';

interface Props {
	phase: StatusPhase[] | undefined;
	phaseToValidate: string | undefined;
}

export const usePhaseError = ({ phase, phaseToValidate }: Partial<Props>) => {
	const {
		isErrorPhaseMessage,
		setIsErrorPhaseMessage,
		errorPhaseMessage,
		setErrorPhaseMessage,
	} = React.useContext(PhaseErrorContext);

	const getPhaseToPutErrorMessage = (): PhaseNameCase | undefined => {
		if (!phase) return;

		const phaseData = phase.findLast(
			(phaseCurrent) => phaseCurrent.started_date
		);
		if (phaseData) {
			return phaseData.fase_name;
		}
		return undefined;
	};

	const handleSetErrorMessage = () => {
		const currentPhase = getPhaseToPutErrorMessage();
		if (currentPhase && !phaseToValidate?.includes(currentPhase)) {
			setIsErrorPhaseMessage(true);
			setErrorPhaseMessage(`Please click 'Move to Next Phase' to proceed.`);
		}
		setTimeout(() => {
			setIsErrorPhaseMessage(false);
		}, 10000);
	};

	return {
		isErrorPhaseMessage,
		setIsErrorPhaseMessage,
		getPhaseToPutErrorMessage,
		handleSetErrorMessage,
		errorPhaseMessage,
	};
};
